import { StudentSectionSettingTypeCodes } from 'const';
import { civilWidgetVisibilityHooks } from 'hooks';
import { civilClubsSelector, civilContestsSelector, civilRewardsSelector, civilSectionsSelector } from 'selectors';
import { getDataLoadRequests } from 'utils';

import { SectionLoaderConfig } from './types';

export const getCivilLoaderConfig = (): SectionLoaderConfig => {
  return [
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.civilReward,
      requests: getDataLoadRequests().civilRewards,
      loadingSelector: civilRewardsSelector,
      dataSelector: (state) => civilRewardsSelector(state).content.length > 0,
      useWidgetVisibility: civilWidgetVisibilityHooks.useRewards,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.civilClub,
      requests: getDataLoadRequests().civilClubs,
      loadingSelector: civilClubsSelector,
      dataSelector: (state) => civilClubsSelector(state).content.length > 0,
      useWidgetVisibility: civilWidgetVisibilityHooks.useClubs,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.civilContest,
      requests: getDataLoadRequests().civilContests,
      loadingSelector: civilContestsSelector,
      dataSelector: (state) => civilContestsSelector(state).content.length > 0,
      useWidgetVisibility: civilWidgetVisibilityHooks.useContests,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.civilUnit,
      requests: getDataLoadRequests().civilSections,
      loadingSelector: civilSectionsSelector,
      dataSelector: (state) => civilSectionsSelector(state).content.length > 0,
      useWidgetVisibility: civilWidgetVisibilityHooks.useSections,
    },
  ];
};
